import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageSquare, X } from 'lucide-react';
const purchases = [{
  name: 'Camila',
  city: 'CABA'
}, {
  name: 'Martín',
  city: 'Córdoba'
}, {
  name: 'Julieta',
  city: 'Rosario'
}, {
  name: 'Facundo',
  city: 'Mendoza'
}, {
  name: 'Agustina',
  city: 'Mar del Plata'
}, {
  name: 'Sofía',
  city: 'La Plata'
}, {
  name: 'Tomás',
  city: 'Neuquén'
}];
export function SocialProof() {
  const [currentPurchase, setCurrentPurchase] = useState<{
    name: string;
    city: string;
  } | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showRandomPurchase = () => {
      const randomPerson = purchases[Math.floor(Math.random() * purchases.length)];
      setCurrentPurchase(randomPerson);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    };
    const initialTimer = setTimeout(showRandomPurchase, 4000);
    const interval = setInterval(() => {
      showRandomPurchase();
    }, Math.random() * 10000 + 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-146">
      {isVisible && currentPurchase && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 w-80 bg-white rounded-xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.2)] p-4 flex items-start gap-4 border border-gray-200" data-id="element-147">
          <div className="bg-sky-100 p-2.5 rounded-full flex-shrink-0 mt-1" data-id="element-148">
            <MessageSquare className="w-5 h-5 text-sky-600" data-id="element-149" />
          </div>
          <div className="flex-grow pr-4" data-id="element-150">
            <div className="flex justify-between items-start mb-1" data-id="element-151">
              <p className="text-[10px] font-bold text-gray-500 tracking-wider uppercase" data-id="element-152">
                Alguien acaba de comprar
              </p>
              <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 absolute top-3 right-3" data-id="element-153">
                <X className="w-4 h-4" data-id="element-154" />
              </button>
            </div>
            <p className="text-sm font-bold text-gray-900 mb-1" data-id="element-155">
              Sistema Dancers Pro
            </p>
            <p className="text-xs text-gray-600" data-id="element-156">
              {currentPurchase.name} de {currentPurchase.city}
            </p>
            <p className="text-[10px] text-gray-400 mt-1 italic" data-id="element-157">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}